import { CheckRounded, CloseRounded } from "@mui/icons-material";
import { Box, Link, Typography } from "@mui/material";
import { createColumnHelper } from "@tanstack/react-table";
import { DateTime } from "luxon";
import { Links } from "src/constants";
import type { OrganizationReportRow } from "src/models";

const columnHelper = createColumnHelper<OrganizationReportRow>();

const columnsConfig = () => {
  return [
    columnHelper.accessor("teamId", {
      id: "Team ID",
      header: () => <Typography variant="caption">TEAM ID</Typography>,
    }),
    columnHelper.accessor("teamName", {
      id: "Team Name",
      header: () => <Typography variant="caption">TEAM NAME</Typography>,
      cell: (props) => (
        <Link href={Links.Team(props.row.original.teamSlug!)} target="_blank">
          {props.getValue()}
        </Link>
      ),
      enableHiding: false,
    }),
    columnHelper.accessor("teamSlug", {
      id: "Team Slug",
      header: () => <Typography variant="caption">TEAM SLUG</Typography>,
    }),
    columnHelper.accessor("connectedToTeam", {
      id: "Context Team",
      header: () => <Typography variant="caption">CONTEXT TEAM</Typography>,
    }),
    columnHelper.accessor("roleName", {
      id: "Role Name",
      header: () => <Typography variant="caption">ROLE NAME</Typography>,
      cell: (props) => (
        <Link href={Links.Role(props.row.original.roleId!)} target="_blank">
          {props.getValue()}
        </Link>
      ),
      enableHiding: false,
    }),
    columnHelper.accessor(
      (row) => ((row.engagementPercentage ?? 0) > 0 ? `${row.engagementPercentage}%` : "As Needed"),
      {
        id: "Role Engagement",
        header: () => <Typography variant="caption">ROLE ENGAGEMENT</Typography>,
      },
    ),
    columnHelper.accessor((row) => row.isPrimaryRole ?? false, {
      id: "Primary Role",
      header: () => <Typography variant="caption">PRIMARY ROLE</Typography>,
      cell: (props) => (
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          {props.getValue() ? <CheckRounded /> : <CloseRounded />}
        </Box>
      ),
    }),
    columnHelper.accessor((row) => row.roleTags, {
      id: "Role Tags",
      header: () => <Typography variant="caption">ROLE TAGS</Typography>,
    }),
    columnHelper.accessor("personName", {
      id: "Person Name",
      header: () => <Typography variant="caption">PERSON NAME</Typography>,
      cell: (props) => (
        <Link href={Links.User(props.row.original.personId)} target="_blank">
          {props.getValue()}
        </Link>
      ),
      enableHiding: false,
    }),
    columnHelper.accessor("personEmail", {
      id: "Person Email",
      header: () => <Typography variant="caption">PERSON EMAIL</Typography>,
      enableHiding: false,
    }),
    columnHelper.accessor("personLocation", {
      id: "Person Location",
      header: () => <Typography variant="caption">PERSON LOCATION</Typography>,
    }),
    columnHelper.accessor(
      (row) =>
        row.personDateJoined
          ? DateTime.fromISO(row.personDateJoined, { zone: "utc" }).toLocaleString(DateTime.DATE_MED)
          : "",
      {
        id: "Person Date Joined",
        header: () => <Typography variant="caption">PERSON DATE JOINED</Typography>,
      },
    ),
  ];
};

export { columnsConfig };
